/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { TViewComponent } from "../../../view/IView";
import { IntegrationEditorEdit } from "./IntegrationEditorEdit";
import { Layout } from "../../../ui/components/Layout/Layout";
import { IntegrationEditorToolbar } from "./components/IntegrationEditorToolbar";
import { IntegrationEditorSecondaryToolbar } from "./components/IntegrationEditorSecondaryToolbar";
import { IntegrationEditorSidebarToolbar } from "./components/IntegrationEditorSidebarToolbar";
import { IntegrationEditorSidebarContent } from "./components/IntegrationEditorSidebarContent";
import { IntegrationEditorContent } from "./components/IntegrationEditorContent";

export const IntegrationEditorEditComponent: TViewComponent<IntegrationEditorEdit> = ({ view }) => {
	const integrationType = useMemo(() => view.getIntegrationType(), []);
	const layoutState = useMemo(() => view.getLayout(), []);

	const renderComponent = (componentName: string) => {
		switch (componentName) {
			case "toolbar":
				return <IntegrationEditorToolbar view={view} />;
			case "secondaryToolbar":
				return <IntegrationEditorSecondaryToolbar view={view} />;
			case "sidebarToolbar":
				return <IntegrationEditorSidebarToolbar />;
			case "sidebarContent":
				return <IntegrationEditorSidebarContent integrationType={integrationType} />;
			case "mainContent":
				return <IntegrationEditorContent view={view} />;
			default:
				return <p>Error: Undefined panel {componentName}.</p>;
		}
	};

	return <Layout state={layoutState} renderComponent={renderComponent} />;
};
